export default {
  "appKey": "key",
  "host": "",
  "imgBaseUrl":"http://images.mkzoo.com",
  "baseConfig": {
      "agreeUrl":"https://m.baidu.com/",
  },
  "Auth": {
    "Login": "http://api.baozhuanla.com/auth/login?url={url}"
  },
  "api": {
    "baseURL": "/",
    "payload": {
      "_source": "weixin"
    }
  },
  "wx": {
    "shareConfig":{
      "title":"「名医问答」-知名专家在线答疑解惑，大病小病你来问",
      "desc":"「铁锋帮你忙」栏目组倾情打造的健康咨询平台，名医解答，惠及百姓",
      "link":"/member/home",
      "imgUrl":"http://images.mkzoo.com/2017-03/share-icon.jpg",
     },
    "jsApiList": [
      "onMenuShareTimeline",
      "onMenuShareAppMessage",
      "onMenuShareQQ",
      "onMenuShareWeibo",
      "onMenuShareQZone",
      "chooseWXPay",
      "startRecord",
      "stopRecord",
      "onVoiceRecordEnd",
      "playVoice",
      "pauseVoice",
      "stopVoice",
      "onVoicePlayEnd",
      "uploadVoice",
      "downloadVoice"
    ],
    "defaultSDK": "//res.wx.qq.com/open/js/jweixin-1.0.0.js"
  },
  "Storage": {
    "storageId": "DOCTOR_DEV",
    "liftTime": 30 * 24 * 60 * 60 * 1000
  }
}



// WEBPACK FOOTER //
// ./src/config/app.dev.js